import React, { useState } from 'react';
import Modal from '../../Common/Components/Modal';
import { toast } from 'react-toastify';

interface DeleteCollectionDialogProps {
  collectionName: string;
  onClose: () => void;
  onDelete: () => Promise<void>;
  show: boolean;
}

const DeleteCollectionDialog: React.FC<DeleteCollectionDialogProps> = ({
  collectionName,
  onClose,
  onDelete,
  show
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await onDelete();
      onClose();
    } catch (error) {
      console.error('Error deleting collection:', error);
      toast.error('Failed to delete collection. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} id="deleteCollectionModal" modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-[calc(100vw-2rem)] mx-4 md:mx-0 md:w-[25rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full">
      <Modal.Header className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500">
        <Modal.Title className="text-16">Delete Collection</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="text-center">
          <p className="text-slate-600 dark:text-zink-200">
            Are you sure you want to delete this collection and all its resources? This action cannot be undone.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex items-center justify-between p-4 mt-auto border-t border-slate-200 dark:border-zink-500">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500 rounded-md transition-colors"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          onClick={handleDelete}
          disabled={isLoading}
          className="px-4 py-2 text-sm bg-red-500 text-white hover:bg-red-600 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          {isLoading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          Delete Collection
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCollectionDialog;